import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { RatioOptions } from '@df/ui/atomic/atomic-options';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
export namespace NCmsImage {
    export interface IComponentData extends NICmsContentComponent.IData {
        image: string;
        ratio: string;
        cta_link?: string;
    }
}
@ICmsComponent<CmsImageComponent>({
    id: 'image',
    name: 'Image',
    image: '/common/cms/image-component.png',
    tags: ['image', 'big', 'banner'],
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        <NICmsContentField.IChoiceField>{
            key: 'ratio',
            type: NICmsContentField.EFieldType.choice,
            title: 'Ratio',
            options: RatioOptions,
            description: 'Proportions width x height',
            default: 'ratio-2-1'
        },
        {
            key: 'image',
            type: NICmsContentField.EFieldType.image,
            title: 'Image',
            default: '',
            required: true
        },
        <NICmsContentField.IField>{
            key: 'cta_link',
            type: NICmsContentField.EFieldType.text,
            title: 'Link'
        }
    ]
})
@Component({
    selector: 'cms-image',
    templateUrl: './cms-image.html',
    styleUrls: ['./cms-image.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ImageModule, HrefComponent, NgClass]
})
export class CmsImageComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: NCmsImage.IComponentData;
}
